import { withChartLayout } from 'components/common';
import Restraints from 'components/features/chart/special-charts/restraints/Restraints';

const RestraintsPage = withChartLayout('Restraints')(Restraints);
export default RestraintsPage;
